import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

const deleteGoal = store => async (state, id) => {
    const userClientId = state.user.selectedUserClientId;
    const clientId = state.user.selectedClientId;

    await sportsApi
        .url(`/clients/${clientId}/goals/${id}`)
        .delete()
        .res();

    const currentState = store.getState();
    const currentGoals = currentState.clients[userClientId].pacing.goals;
    const removeIndex = currentGoals.findIndex(el => {
        return el.id && el.id === id;
    });
    const newGoals = R.remove(removeIndex, 1, currentGoals);

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        pacing: {
                            isLoading: R.F,
                            goals: R.always(newGoals),
                        },
                    },
                },
            },
            store.getState(),
        ),
        true,
    );
};

export default deleteGoal;
